import CompanyModule from './containers/companyModule'

export {default as CompanyModuleLayout} from './components/companyModuleLayout'

export default CompanyModule
